import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '../../store/thunks/authThunks';
import { trackEvent, ANALYTICS_EVENTS } from '../../utils/analytics';
import { useCookieConsent } from '../../hooks/useCookieConsent';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const { loading, resetPasswordSuccess, resetPasswordError } = useSelector(state => state.auth);
  const [email, setEmail] = useState('');
  const { hasAnalyticsConsent } = useCookieConsent();

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(resetPassword({ email }));
    if (hasAnalyticsConsent) {
      trackEvent(ANALYTICS_EVENTS.PASSWORD_RESET_REQUEST);
    }
  };

  if (resetPasswordSuccess) {
    return (
      <div className="max-w-md mx-auto p-6">
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative">
          <p>Password reset instructions have been sent to your email.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4 text-center">Reset Password</h1>
      
      {resetPasswordError && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{resetPasswordError}</span>
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            required
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
            loading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          {loading ? 'Sending...' : 'Reset Password'}
        </button>
      </form>
    </div>
  );
};

export default ForgotPassword; 